import { isMiniHostAppFeatureEnabled } from 'mini-hostapp-feature-flags/lib/isMiniHostAppFeatureEnabled';
import { isMsalFlowEnabled } from 'owa-msaljs/lib/isMsalFlowEnabled';

export const isMsalEnabled = (): boolean => {
    if (!isMsalFlowEnabled()) {
        return false;
    }
    if (isMiniHostAppFeatureEnabled('msalTokenFetch')) {
        return true;
    }
    const urlParams = new URLSearchParams(window.location.search);
    const isMsalTesting = urlParams.has('msalTesting');
    return isMsalTesting;
};
